import { useState, useEffect, useCallback } from "react";
import {
  BodyComponent,
  TableComponent,
  ActionComponent,
  CreateButton, RefreshButton,
  trans,
  HeaderComponent
} from "@comps/components";
import { makeRequest } from "@utils/helpers";
import { Commons, Const } from "../constants";
import { Button, Form, Input, message, Tooltip } from 'antd';
import { PaginationComponent } from "@comps/components";
import { deleteDataReq, getAllDataReq, getReportsFromJobsReq, getReportTypesAndTables } from "./requests";
import { useSelector } from "react-redux";
import CreateRawReport from "./components/CreateRawReport";
import UpdateRawReport from "./components/UpdateRawReport";
import CreateCustomReport from "./components/CreateCustomReport";
import { CopyOutlined, ScheduleOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { Download } from "@mui/icons-material";
import _ from "lodash";
import CopyReportToSaas from "./components/CopyReportToSaas";
import CreatePredefinedReport from "./components/CreatePredefinedReport";
import ScheduleReport from "./components/ScheduleReport";
import { checkPermissions } from "../../../wrappers/commonFunctions";
import UpdateReportName from "./components/UpdateReportName";

const langKey = Const["allReports"].lngKey;
const pageConfig = {
  headers: {
    title: trans(`${langKey}.moduleName`),
    breadcrumb: [
      {
        name: trans(`${langKey}.moduleName`),
        path: Const["allReports"].route
      }
    ]
  }
}

const IndexAllReports = (props) => {
  const navigate = useNavigate()
  const location = useLocation();
  const initialSelectedReport = location.state?.selectedReport;
  const authUser = useSelector((state) => state.auth.authUser);
  const [searchForm] = Form.useForm();
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [childComponent, setChildComponent] = useState(null);
  const [currentPage, setCurrentPage] = useState(1)
  const [searchInput, setSearchInput] = useState(initialSelectedReport?.title || '');
  const [searchTerm, setSearchTerm] = useState(initialSelectedReport?.title || '');
  const [selectedReportType, setSelectedReportType] = useState(null);
  const [selectedReportId, setSelectedReportId] = useState(initialSelectedReport?.id || null);
  const [reportTypes, setReportTypes] = useState([]);
  const [pagination, setPagination] = useState({
    "total": 0,
    "count": 0,
    "per_page": 0,
    "current_page": 0,
    "total_pages": 0,
    "links": {}
  });

  // ==================================
  //   Use States End
  // ==================================

  // ==================================
  //   Table Data End
  // ==================================
  const columns = [

    {
      key: 'title',
      title: trans(`${langKey}.title`),
      render: (record) => {

        return (
          <>
            { record.is_pre_defined ?
              <Tooltip title="Generate Report">
                <span
                  className="da-px-10 da-my-0 mt-2"
                  onClick={ () => generateReport(record) }
                  style={ { cursor: "pointer", textDecoration: "none" } }
                >
                  <u>{ record.title }</u>
                </span>
              </Tooltip>

              :

              <Tooltip title="Generate Report">
                <span className="da-px-10 da-my-0 mt-2" onClick={ () => generateReport(record) } style={ { cursor: 'pointer', textDecoration: 'none' } } ><u>{ record.title }</u> </span>
              </Tooltip>
            }
          </>

        )
      }
    },

    {
      key: 'type',
      title: trans(`${langKey}.report_type_name`),
      render: (record) => (
        record.report_type.name
      )
    },
    {
      key: 'class_name',
      title: 'Class',
      render: (record) => {
        return <span>{ record.class_name }</span>
      }
    },
    {
      key: trans(Commons.actions),
      title: trans(Commons.actions), fixed: 'right',

      render: (record) => {
        return (
          <>

            <ActionComponent
              each={ record }
              onEdit={ onEdit }
              //onView={ () => generateReport(record, record.is_pre_defined) }
              onDelete={ !record.is_pre_defined && onDelete }
            >
              {
                record.is_pre_defined ?
                  <Tooltip title="Generate Report">
                    <span
                      className="da-px-10 da-my-0 mt-2"
                      onClick={ () => generateReport(record) }
                      style={ { cursor: "pointer", textDecoration: "none" } }
                    >
                      <Download />
                    </span>
                  </Tooltip> :
                  <Tooltip title="Generate or Download">
                    <Download className="da-px-10 da-my-0 mt-2 text-primary" onClick={ () => generateReport(record) } style={ { cursor: 'pointer' } } />
                  </Tooltip>
              }


              {
                checkPermissions('reportsAll', 'update') &&
                <Tooltip title="Schedule Report">
                  <ScheduleOutlined className="da-px-10 da-my-0 mt-2 ms-2 text-primary" onClick={ () => scheduleReport(record) } style={ { cursor: 'pointer' } } />
                </Tooltip>
              }


              {
                authUser.super_admin && <Tooltip title="Copy Report to other clients">
                  <CopyOutlined className="da-px-10 da-my-0 mt-2 text-primary ms-2" style={ { cursor: 'pointer' } } onClick={ () => onCopyReport(record) } />
                </Tooltip>
              }

            </ActionComponent>

          </>
        )
      },
    },
  ];

  // ==================================
  //   Table Data End
  // ==================================

  const buildFilters = (searchValue = searchTerm, reportTypeId = selectedReportType) => {
    const filters = [];
    const normalizedSearchValue = typeof searchValue === "string"
      ? searchValue
      : searchValue?.name || "";

    if (normalizedSearchValue.trim()) {
      filters.push(`title_|${normalizedSearchValue.trim()}`);
    }

    if (reportTypeId) {
      filters.push(`report_type_id_|${reportTypeId}`);
    }

    return filters.join(";");
  };

  useEffect(() => {
    getReportTypes();
    getDownloads();
    // eslint-disable-next-line
  }, [props]);

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line
  }, [props, currentPage, searchTerm, selectedReportType]);

  const getAllData = () => {
    setChildComponent(null)
    const payload = {
      page: currentPage,
      filters: buildFilters()
    }
    makeRequest(setLoader, getAllDataReq, payload, onSuccess, onGetAllDataError);
  };
  const onSuccess = (response) => {
    setPagination(response.reports)
    setDataSource(response.reports.data);
  };
  const onGetAllDataError = (err, res) => {
    message.error(res.response.data.message);
  }
  const getReportTypes = () => {
    makeRequest(setLoader, getReportTypesAndTables, null, onGetReportTypesSuccess, onGetReportTypesError);
  };
  const onGetReportTypesSuccess = (response) => {
    setReportTypes(response.report_types || []);
  };
  const onGetReportTypesError = (err, res) => {
    message.error(res?.response?.data?.message || "Unable to load report types");
  };
  //update raw report
  const onEdit = (record) => {
    if (record.is_raw_query && record.query) {
      setChildComponent(<UpdateRawReport onCompleted={ onCompleted } record={ record } disabled={ false } />);
    } else {
      setChildComponent(<UpdateReportName onCompleted={ onCompleted } record={ record } disabled={ false } />);
    }
  };


  const onCopyReport = (record) => {
    setChildComponent(<CopyReportToSaas onCompleted={ onCompleted } record={ record } disabled={ false } />);
  };
  const onCreatePredefinedReport = () => {
    setChildComponent(<CreatePredefinedReport onCompleted={ onCompleted } disabled={ false } />);
  };
  //view 
  // const onViewRawReport = (record) => {
  //   setChildComponent(<UpdateRawReport onCompleted={ onCompleted } record={ record } disabled={ true } />);
  // };

  // const onView = (record) => {
  //   // setChildComponent(<UpdateAttendanceLogs onCompleted={ onCompleted } record={ record } authUser={ authUser } allData={ allData } disabled={ true } />);
  // };

  const onDelete = (record) => {
    const payload = {
      filters: `employee_|${record.employment_id}`, id: record.id
    }
    makeRequest(setLoader, deleteDataReq, payload, onDeleted, onError);
  };
  const onDeleted = (res) => {
    setDataSource(res.reports.data);
    message.success("Record Deleted")
  };

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }

  // Create component modal
  const onCreateCustomReport = () => {
    setChildComponent(<CreateCustomReport onCompleted={ onCompleted } />);
  };
  const onCreateRawReport = () => {
    setChildComponent(<CreateRawReport onCompleted={ onCompleted } />);
  };

  const onCompleted = (data) => {
    // if (data && data.length) {
    //   setDataSource(data);
    // }
    if (data) {
      getAllData();
    }

    setChildComponent(null);
  };
  //schedule report
  const scheduleReport = (record) => {
    setChildComponent(<ScheduleReport onCompleted={ onCompleted } record={ record } disabled={ false } />);
  }
  const generateReport = (record) => {
    const selectedReport = {
      id: record.id,
      title: record.title,
      report_type_id: record.report_type_id || record.report_type?.id || null
    };

    setSelectedReportId(record.id);

    if (record.is_pre_defined && !record.query) {
      navigate(`generate-class/${record.id}`, {
        state: {
          report: record,
          previewMode: "class-based-download",
          selectedReport
        }
      });
      return;
    }

    navigate(`generate/${record.id}`, {
      state: {
        report: record,
        previewMode: 'preview-before-download',
        selectedReport
      }
    });
  }
  const getDownloads = () => {
    makeRequest(setLoader, getReportsFromJobsReq, null, onSuccessReports, onErrorReports);
  }

  const onSuccessReports = (data, res) => {
  }
  const onErrorReports = (err) => {

  }
  // const viewDownloads=()=>{
  //   setDownloadsComponent(<ViewReports data={reportJobs} onCompleted={ onCompleted }/>)
  // }

  const onSearchReport = (value) => {
    setSearchInput(value);
    debouncedGetReports(value)
  }

  const onSearchSubmit = (values) => {
    const submittedValue = values?.name || "";
    debouncedGetReports.cancel();
    setSearchInput(submittedValue);
    setCurrentPage(1);
    setSearchTerm(submittedValue);
  };

  const debouncedGetReports = useCallback(
    _.debounce((value) => {
      setCurrentPage(1);
      setSearchTerm(value);
    }, 500),
    [] // Empty array ensures the function is created only once
  );

  useEffect(() => {
    return () => debouncedGetReports.cancel();
  }, [debouncedGetReports]);

  useEffect(() => {
    searchForm.setFieldsValue({ name: searchInput });
  }, [searchForm, searchInput]);

  useEffect(() => {
    const returnReport = location.state?.selectedReport;

    if (!returnReport) {
      return;
    }

    const reportTitle = returnReport.title || "";

    debouncedGetReports.cancel();
    setSelectedReportId(returnReport.id || null);
    setSearchInput(reportTitle);
    setSearchTerm(reportTitle);
    setCurrentPage(1);

    navigate(location.pathname, { replace: true, state: null });
  }, [debouncedGetReports, location.pathname, location.state, navigate]);

  const onReportTypeChange = (reportTypeId) => {
    setCurrentPage(1);
    setSelectedReportType(reportTypeId);
  };
  return (
    <>

      { childComponent }
      <BodyComponent pagination={ pagination } setCurrentPage={ setCurrentPage } currentPage={ currentPage } filters="">
        <HeaderComponent headers={ pageConfig.headers } modkey={ props.modkey }>

          <RefreshButton onClick={ getAllData } />
          <CreateButton onClick={ onCreateCustomReport } text='Create Custom Report' />
          <CreateButton onClick={ onCreateRawReport } text='Create Raw Report' />
          { authUser.super_admin || process.env.REACT_APP_ENV === "local" ? <CreateButton onClick={ onCreatePredefinedReport } text='Create Predefined Report' /> : '' }

          {/* <Popover content={ downloadsComponent } title="Downloads" trigger="click" placement="right" onClick={()=>viewDownloads()}>
          <ButtonComponent text={`Downloads(${reportJobs.length})`} />
        </Popover> */}
          {/* <FilterButton onClick={ onOpenFilter } /> */ }
        </HeaderComponent>
        <Form form={ searchForm } { ...formLayout } onFinish={ onSearchSubmit }>
          <Form.Item name="name"
            className="da-mb-16" style={ { marginRight: '60%' } }>
            <Input
              placeholder="Search By name"
              value={ searchInput }
              onChange={ (e) => onSearchReport(e.target.value) }
            />
          </Form.Item>

        </Form>
        { reportTypes.length > 0 && (
          <div className="da-mb-16">
            <div className="da-mb-8" style={ { fontWeight: 500 } }>
              Filter By Report Type
            </div>
            <div style={ { display: "flex", flexWrap: "wrap", gap: "8px" } }>
              <Button
                type={ selectedReportType === null ? "primary" : "default" }
                onClick={ () => onReportTypeChange(null) }
              >
                All
              </Button>
              { reportTypes.map((reportType) => (
                <Button
                  key={ reportType.id }
                  type={ selectedReportType === reportType.id ? "primary" : "default" }
                  onClick={ () => onReportTypeChange(reportType.id) }
                >
                  { reportType.name }
                </Button>
              )) }
            </div>
          </div>
        ) }
        <TableComponent modkey={ props.modkey }
          loader={ loader }
          columns={ columns }
          dataSource={ dataSource }
          rowClassName={ (record) => record.id === selectedReportId ? "ant-table-row-selected" : "" }
          onRow={ (record) => ({
            style: {
              cursor: "pointer",
              background: record.id === selectedReportId ? "#edf5ff" : "transparent",
            },
          }) }
        //pagination={ { ...pagination, total: totalRecords } }
        //onChange={ handleTableChange }
        />

      </BodyComponent>
      <PaginationComponent pagination={ pagination } modkey={ props.modkey } setCurrentPage={ setCurrentPage } currentPage={ currentPage } />
    </>
  );
};

export default IndexAllReports;


const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
